// extracted by mini-css-extract-plugin
module.exports = {"message":"confirmationButton_message__1a6HO"};